import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { footerContent, navigationLinks } from '../data/mock';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (href) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-[#0a0a0a] border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-[7.6923%]">
        {/* Main Footer Content */}
        <div className="py-16 grid md:grid-cols-3 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-2 space-y-6">
            <img
              src="https://customer-assets.emergentagent.com/job_94f5a94a-682d-481e-b75c-a692290dbeab/artifacts/ksy0u9nl_Logo.png"
              alt="Prysh AI Labs"
              className="h-14 w-auto object-contain cursor-pointer"
              onClick={() => navigate('/')}
            />
            <p className="text-white/50 text-lg max-w-sm leading-relaxed">
              {footerContent.tagline}
            </p>
            {/* Contact Email */}
            <p className="text-white/60 text-lg">
              Contact us at{' '}
              <a 
                href="mailto:info@pryshai.com" 
                className="text-[#00FFD1] hover:text-[#00FFD1]/80 transition-colors duration-300"
              >
                info@pryshai.com
              </a>
            </p>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-white font-semibold mb-6">Navigation</h4>
            <nav className="space-y-4">
              {navigationLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.href)}
                  className="block text-white/50 hover:text-[#00FFD1] transition-colors duration-300 text-left"
                >
                  {link.label}
                </button>
              ))}
              <button
                onClick={() => navigate('/contact')}
                className="block text-white/50 hover:text-[#00FFD1] transition-colors duration-300 text-left"
              >
                Contact Us
              </button>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/5 flex justify-center items-center">
          <p className="text-white/40 text-sm">
            ©2026 Prysh AI Labs Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
